import * as Toolkit from '../../../toolkit/index';
import * as CubeTree from '../../../cubeTree/index';
import CodiSystem from '../../../codiSystem/index';
import Utils from '../../../utils/util';
import { layoutSplit } from './layoutSplit';

// 查找层板插入对象
function findTargetLayerChild(hoverLayer: CubeId, mousePoint: MousePoint, dragCubes: CubeId[]): CubeId|null {
    let layerChildren: CubeId[] = CubeTree.findChildCubeIdsWithSkip(hoverLayer, dragCubes);
    let layerChildrenCoordinate: CubePaintCoordinate[] = CodiSystem.getPaintCoordinates(layerChildren);
    let layerCoordinate: PaintCoordinate = CodiSystem.getPaintCoordinate(hoverLayer);
    let layoutArea: CubePaintCoordinate[] = layoutSplit(layerChildrenCoordinate, Utils.math(layerCoordinate.left, layerCoordinate.width, '+'));

    if (!layerChildrenCoordinate.length) {
        return hoverLayer;
    }

    for(let i = 0; i < layoutArea.length; i++) {
        let coordinate: CubePaintCoordinate = layoutArea[i];
        let point: MousePoint = {
            ...mousePoint
        };
        let rect: Rect = {
            left: coordinate.left,
            top: coordinate.top,
            width: coordinate.width,
            height: coordinate.height
        };

        if (Toolkit.pointXInRect(point, rect)) {
            return coordinate.id;
        }
    }

    return null;
}

export {
    findTargetLayerChild
};
